import { render, staticRenderFns } from "./IconBase24.vue?vue&type=template&id=0344581b&scoped=true"
import script from "./IconBase24.vue?vue&type=script&lang=js"
export * from "./IconBase24.vue?vue&type=script&lang=js"
import style0 from "./IconBase24.vue?vue&type=style&index=0&id=0344581b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344581b",
  null
  
)

export default component.exports